import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <Quote className="text-blue-600" size={36} />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Our Clients Say
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Don't just take our word for it - hear from our satisfied clients
            </p>
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 group relative"
              >
                <div className="absolute top-6 right-6 text-blue-100 group-hover:text-blue-200 transition-colors duration-300">
                  <Quote size={48} />
                </div>

                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <Star
                      key={index}
                      className="text-amber-400 fill-amber-400"
                      size={20}
                    />
                  ))}
                </div>

                <p className="text-gray-700 leading-relaxed mb-6 relative z-10">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center space-x-4 border-t border-gray-200 pt-6">
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 text-lg mb-4">
              Join <span className="font-bold text-blue-600">500+ satisfied clients</span> who trust us
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;